module.exports = __webpack_public_path__ + "static/city2-93e80d63711c2752bb7ee44ec2163353.svg";